import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as api from "api/api";

import Option from "components/MarketPlace/CardContainer/Option";
import { useQuery } from "utils/useQuery";
import { MARKET_PLACE } from "src/constants/routes";
import { CHEVRON_LEFT } from "src/constants/images";
import CardContainer from "components/MarketPlace/CardContainer/CardContainer";
import Filter from "components/MarketPlace/Filter/Filter";
import { useWindowDimensions } from "utils/windowDimension";
import MarketPlaceSkeleton from "components/Loader/Skeleton/MarketPlaceSkeleton";
import SEO from "components/SEO";
import {
  fetchFilterData,
  fetchMarketPlaceQuery,
  fetchMarketPlaceData,
  setCurrentPage,
} from "../redux/actions/marketplace";
import { isEmpty } from "utils/isEmpty";
import { createQuery } from "utils/createQuery";

const MarketPlace = () => {
  const { width } = useWindowDimensions();

  const { data, isLoading, currentPage } = useSelector(
    ({ marketplace }) => marketplace
  );

  const { filterData, isFilterLoading } = useSelector(
    (state) => state.marketplace
  );

  const dispatch = useDispatch();
  const path = useQuery();
  const query = createQuery(path);
  const navigate = useNavigate();

  const [hide, setHide] = useState(false);
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState([]);
  const [transactionAnalytics, setTransactionAnalytics] = useState({});
  const [removeSearch, setRemovedSearch] = useState(false);
  const [pageIndex, setPageIndex] = useState(currentPage);
  const [page, setPage] = useState({
    prev: 0,
    next: 12,
  });

  const forSale = filterData?.status?.for_sale;

  useEffect(() => {
    let isMounted = true;
    
    const initializeMarketPlace = async () => {
      try {
        console.log(path);
        console.log(createQuery(path));
        dispatch(fetchMarketPlaceQuery(createQuery(path)));
        console.log(query);
        if (currentPage !== 1) {
          dispatch(setCurrentPage(1));
          setPageIndex(1);
        }
        if (!path) {
          dispatch(fetchMarketPlaceData(currentPage));
        }
        if (isMounted) {
          setLoading(false);
        }
        dispatch(fetchFilterData());
      } catch (error) {
        console.error('Error initializing marketplace:', error);
      }
    };

    initializeMarketPlace();

    return () => {
      isMounted = false;
      dispatch(fetchMarketPlaceQuery(""));
    };
  }, []);

  useEffect(() => {
    if (width < 992) {
      setHide(true);
    } else {
      setHide(false);
    }
  }, [width]);

  const handleFilter = () => {
    setHide(false);
  };

  const handleRedirection = () => {
    navigate(-1)();
  };

  const optionRemoveHandler = (option, key) => {
    let path;
    console.log(`[Input]:Options(${option} & Key(${key}))`);
    console.log(options);
    if (options.length <= 1) {
      if (query.includes("sort_by")) {
        console.log("has sort by");
        console.log(`${key}=${option}`);
        if (query.includes(`&${key}`)) {
          path = query.replace(`&${key}=${option}`, "");
        } else {
          path = query.replace(`?${key}=${option}&`, "?");
        }
      } else {
        path = query.replace(`?${key}=${option}`, "");
      }
    } else {
      path = query
        .replace(`?${key}=${option}&`, "?")
        .replace(`&${key}=${option}`, "")
        .replace(`&${key}=${option.replaceAll("%20", " ")}`, "");
    }
    console.log(path);
    setOptions((prev) => {
      const previous = prev.filter((element) => element.value != option);
      return previous;
    });

    setRemovedSearch(true);
    dispatch(fetchMarketPlaceQuery(path));

    navigate(path);
  };

  const handleItemName = (value, key) => {
    if (key != "attribute") {
      if (key == "for_sale") {
        let name;
        Object.entries(forSale).map(([k, v]) => {
          if (k == value) {
            name = v.replaceAll("%20", " ");
          }
        });
        return name;
      } else {
        return value.replaceAll("%20", " ");
      }
    } else {
      const splitElement = value.split("-");
      let item = "";

      if (splitElement[1].search("%20")) {
        item = splitElement.slice(1).join("-").replaceAll("%20", " ");
      } else {
        item = splitElement.slice(1).join("-");
      }

      return item;
    }
  };

  const handleAllClear = () => {
    const { sort_by } = useQuery();
    let path;

    if (sort_by) {
      path = `${MARKET_PLACE.INDEX}?sort_by=${sort_by[0]}`;
    } else {
      path = `${MARKET_PLACE.INDEX}`;
    }
    dispatch(fetchMarketPlaceQuery(path));
    dispatch(setCurrentPage(1));
    navigate(path);
  };
  const metaData = {
    pageTitle: `Marketplace | GangstaBet: A Digital Collectible  `,
    pageDescription:
      "GangstaBet is a collection of 5555 unique Gangsters & Detectives with changeable names & stats.",
    pageKeywords: null,
    pageImage: null,
  };
  return (
    <SEO pageMetaData={metaData}>
      {!isEmpty(filterData) && !isFilterLoading && !loading ? (
        <div className="market-place">
          {!hide && width < 992 && (
            <div
              className="vh-100 overlay w-100 cursor"
              role="button"
              onClick={() => setHide(true)}
            />
          )}

          <div className="content d-flex">
            <Filter
              hide={hide}
              handleClose={() => setHide(true)}
              filterData={filterData}
              optionRemoveHandler={optionRemoveHandler}
              setPageIndex={setPageIndex}
            />
            <CardContainer
              removeSearch={removeSearch}
              setRemovedSearch={setRemovedSearch}
              setOptions={setOptions}
              options={options}
              transactionAnalytics={transactionAnalytics}
              handleItemName={handleItemName}
              optionRemoveHandler={optionRemoveHandler}
              handleAllClear={handleAllClear}
              handleFilter={handleFilter}
              sortByList={filterData.sort_by}
              pageIndex={pageIndex}
              setPageIndex={setPageIndex}
              page={page}
              setPage={setPage}
            />
          </div>
        </div>
      ) : (
        <div className="market-container">
          <div className="container">
            <MarketPlaceSkeleton />
          </div>
        </div>
      )}
    </SEO>
  );
};

export default MarketPlace;
